import type React from 'react';

import { FormField, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { INSUFFICIENT_FUNDS_FEE } from '../../../constants/index';
import InlineTooltip from '../../Widgets/InlineTooltip';
import CurrencyInput from '../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function InsufficientFundsFee_v1({ section, setSectionValues }: Props): JSX.Element {
  function disableInsufficientFundsFee(): void {
    setSectionValues({
      [INSUFFICIENT_FUNDS_FEE.FIELD_NAME.IS_ENABLED]: false,
      [INSUFFICIENT_FUNDS_FEE.FIELD_NAME.AMOUNT]: '',
    });
  }

  function enableInsufficientFundsFee(): void {
    setSectionValues({
      [INSUFFICIENT_FUNDS_FEE.FIELD_NAME.IS_ENABLED]: true,
      [INSUFFICIENT_FUNDS_FEE.FIELD_NAME.AMOUNT]: '',
    });
  }

  function onAmountChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [INSUFFICIENT_FUNDS_FEE.FIELD_NAME.AMOUNT]: value });
  }

  const insufficientFundEnabled = section.getFieldValue(INSUFFICIENT_FUNDS_FEE.FIELD_NAME.IS_ENABLED);
  return (
    <FormField
      required
      label={
        <>
          <Label>
            Will you charge a fee if a payment gets{' '}
            <InlineTooltip
              tooltipBodyText="Reversals are usually caused by checks being returned for insufficient funds or by the tenant stopping or
          canceling a check. A fee charged for reversal of payment is different from a late fee."
            >
              reversed
            </InlineTooltip>
            ?
          </Label>
        </>
      }
      control={
        <YesAndNoExpansion
          yesHandler={enableInsufficientFundsFee}
          noHandler={disableInsufficientFundsFee}
          yesActive={insufficientFundEnabled}
        >
          <FormField
            required
            label={<Label id="fee-amount">{INSUFFICIENT_FUNDS_FEE.LABEL.AMOUNT}</Label>}
            control={
              <CurrencyInput
                aria-labelledby="fee-amount"
                value={section.getFieldValue(INSUFFICIENT_FUNDS_FEE.FIELD_NAME.AMOUNT)}
                onBlur={onAmountChange}
                onChange={onAmountChange}
                endAdornment="flat fee"
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
